// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"_3RlkF3yNs-GUNuKFlTHQGF","tos":"_2eyS1PUzNwv--HRQS0vemv"};